import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles, useTheme } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { useMediaQuery } from '@material-ui/core';

const MaterialDialog = ({
  open,
  maxWidth,
  dialogStyle,
  onRequestClose,
  title,
  children,
  actions,
  message,
  classes,
}) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <Dialog
      open={open}
      maxWidth={maxWidth}
      style={dialogStyle}
      onClose={onRequestClose}
      PaperProps={{ classes: { root: classes.paper } }}
      classes={{
        paperWidthMd: classes.paperWidthMd,
        paper: classes.paper,
      }}
      fullScreen={fullScreen}
    >
      <DialogTitle className={classes.gradient}>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{message}</DialogContentText>
        {children}
      </DialogContent>
      <DialogActions>
        {actions}
      </DialogActions>
    </Dialog>
  );
};

MaterialDialog.propTypes = {
  open: PropTypes.bool,
  title: PropTypes.string,
  message: PropTypes.string,
  actions: PropTypes.array,
  maxWidth: PropTypes.string,
  children: PropTypes.any,
  classes: PropTypes.object,
  dialogStyle: PropTypes.object,
  onRequestClose: PropTypes.func,
};

MaterialDialog.defaultProps = {
  open: false,
  title: '',
  message: '',
  actions: [],
  maxWidth: 'sm',
  children: [],
  classes: null,
  dialogStyle: null,
  onRequestClose: () => {},
};

const styles = theme => ({
  gradient: {
    // color: 'white',
    fontWeight: 'bold',
    fontSize: 18,
    padding: 10,
    // background: `linear-gradient(135deg, ${theme.palette.secondary.main} 0%, ${theme.palette.primary.main} 100%)`,
  },

  paperWidthMd: {
    maxWidth: 650,
    display: 'flex',
    justifyContent: 'center',
    margin: 'auto',
  },
  paper: {
    minWidth: 0,
  },
});

export default withStyles(styles)(MaterialDialog);



// WEBPACK FOOTER //
// ./src/app/main/dialogs/dialog/dialog.js